import React from 'react'
import PropTypes from 'prop-types'
import { useViewport } from '../utils'
import { X } from 'react-feather'
import colors from '../utils/colors'

const TagItem = ({ value, onClose, withClose }) => {
  const { isMobile } = useViewport()

  return (
    <div
      className="border rounded flex items-center justify-between px-2 lg:px-3 py-2"
      style={{borderColor: colors.blue}}
    >
      <p className="leading-none lg:leading-tight text-sm text-gray-444 pr-2 lg:pr-3">{value}</p>
      {
        withClose &&
        <button type="button" className="appearance-none" onClick={onClose}>
          <X width={isMobile ? 14 : 16} />
        </button>
      }
    </div>
  )
}

TagItem.propTypes = {
  value: PropTypes.string,
  onClose: PropTypes.func,
  withClose: PropTypes.bool
}

TagItem.defaultProps = {
  onClose: () => {},
  withClose: true
}

export { TagItem }
